import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

/**
 * Toggle for enabling the new Replit/Cursor like DesignAI v3 UI
 * @returns `true` if the toggle is enabled
 */
export const useWhiteLabellingEnabled = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  return !!config?.custom_ui_labels?.white_labelled;
};
